export default "__VITE_ASSET__BCkEl4WQ__"